import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ActivationPage from './ActivationPage';
import InviteAcceptPage from '../pages/InviteAcceptPage';
import Gateway from './Gateway';
import { RequireAuthenticated } from './auth/RequireAuthenticated';
import { WorkspaceLayout } from './WorkspaceLayout';
import { RequireCapability } from './auth/RequireCapability';
import { getProtectedRoutes, toNestedRoutePath } from './layout/navigationRegistry';
import { FirstRunSetup } from '../pages/FirstRunSetup';
import ErrorBoundary from './ErrorBoundary';
import { OnboardingPage } from '../modules/onboarding/pages/OnboardingPage';
import { LandingPage } from '../pages/LandingPage';
import { TermosPage } from '../pages/TermosPage';
import { PrivacidadePage } from '../pages/PrivacidadePage';
import { RegisterScreen } from './RegisterScreen';

export default function AppRouter() {
  const protectedRoutes = getProtectedRoutes();

  return (
    <Routes>
      <Route path="/" element={<Gateway />} />
      <Route path="/activate" element={<ActivationPage />} />
      <Route path="/invite" element={<InviteAcceptPage />} />
      <Route path="/setup" element={<FirstRunSetup />} />

      {/* Public pages — no auth required */}
      <Route path="/welcome" element={<LandingPage />} />
      <Route path="/login" element={<RegisterScreen />} />
      <Route path="/termos" element={<TermosPage />} />
      <Route path="/privacidade" element={<PrivacidadePage />} />

      {/* SaaS onboarding — needs auth but no workspace capability */}
      <Route element={<RequireAuthenticated />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
      </Route>

      <Route element={<RequireAuthenticated />}>
        <Route element={<ErrorBoundary><WorkspaceLayout /></ErrorBoundary>}>
          {protectedRoutes.map((route) => {
            if (route.redirectTo) {
              return (
                <Route
                  key={route.id}
                  path={toNestedRoutePath(route.path)}
                  element={<Navigate to={route.redirectTo} replace />}
                />
              );
            }

            if (!route.component) {
              return null;
            }

            const pageElement = (
              <ErrorBoundary moduleName={route.id}>
                {React.createElement(route.component)}
              </ErrorBoundary>
            );

            return (
              <Route
                key={route.id}
                path={toNestedRoutePath(route.path)}
                element={
                  route.capability ? (
                    <RequireCapability capability={route.capability} realRoleOnly={route.realRoleOnly}>
                      {pageElement}
                    </RequireCapability>
                  ) : (
                    pageElement
                  )
                }
              />
            );
          })}
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
